// GitHub's Octicons (MIT, @primer/octicons). Only the icons imported here end up in
// the bundle: esbuild loads the .svg files as text (see build.js).
import m from './m.js'
import bold from '@primer/octicons/build/svg/bold-16.svg'
import code from '@primer/octicons/build/svg/code-16.svg'
import heading from '@primer/octicons/build/svg/heading-16.svg'
import italic from '@primer/octicons/build/svg/italic-16.svg'
import link from '@primer/octicons/build/svg/link-16.svg'
import listOrdered from '@primer/octicons/build/svg/list-ordered-16.svg'
import listUnordered from '@primer/octicons/build/svg/list-unordered-16.svg'
import quote from '@primer/octicons/build/svg/quote-16.svg'
import tasklist from '@primer/octicons/build/svg/tasklist-16.svg'
import crossReference from '@primer/octicons/build/svg/cross-reference-16.svg'
import fileDiff from '@primer/octicons/build/svg/file-diff-16.svg'
import project from '@primer/octicons/build/svg/project-16.svg'
import skip from '@primer/octicons/build/svg/skip-16.svg'
import sync from '@primer/octicons/build/svg/sync-16.svg'
import sparkle from '@primer/octicons/build/svg/sparkle-16.svg'
import terminal from '@primer/octicons/build/svg/terminal-16.svg'
import check from '@primer/octicons/build/svg/check-16.svg'
import checkCircleFill from '@primer/octicons/build/svg/check-circle-fill-16.svg'
import chevronDown from '@primer/octicons/build/svg/chevron-down-16.svg'
import chevronRight from '@primer/octicons/build/svg/chevron-right-16.svg'
import comment from '@primer/octicons/build/svg/comment-16.svg'
import copy from '@primer/octicons/build/svg/copy-16.svg'
import dotFill from '@primer/octicons/build/svg/dot-fill-16.svg'
import fold from '@primer/octicons/build/svg/fold-16.svg'
import gear from '@primer/octicons/build/svg/gear-16.svg'
import gitBranch from '@primer/octicons/build/svg/git-branch-16.svg'
import gitCommit from '@primer/octicons/build/svg/git-commit-16.svg'
import gitMerge from '@primer/octicons/build/svg/git-merge-16.svg'
import gitPullRequest from '@primer/octicons/build/svg/git-pull-request-16.svg'
import gitPullRequestClosed from '@primer/octicons/build/svg/git-pull-request-closed-16.svg'
import gitPullRequestDraft from '@primer/octicons/build/svg/git-pull-request-draft-16.svg'
import issueClosed from '@primer/octicons/build/svg/issue-closed-16.svg'
import issueOpened from '@primer/octicons/build/svg/issue-opened-16.svg'
import issueReopened from '@primer/octicons/build/svg/issue-reopened-16.svg'
import linkExternal from '@primer/octicons/build/svg/link-external-16.svg'
import lock from '@primer/octicons/build/svg/lock-16.svg'
import markGithub from '@primer/octicons/build/svg/mark-github-16.svg'
import milestone from '@primer/octicons/build/svg/milestone-16.svg'
import paperclip from '@primer/octicons/build/svg/paperclip-16.svg'
import pencil from '@primer/octicons/build/svg/pencil-16.svg'
import person from '@primer/octicons/build/svg/person-16.svg'
import personAdd from '@primer/octicons/build/svg/person-add-16.svg'
import plus from '@primer/octicons/build/svg/plus-16.svg'
import repo from '@primer/octicons/build/svg/repo-16.svg'
import search from '@primer/octicons/build/svg/search-16.svg'
import signOut from '@primer/octicons/build/svg/sign-out-16.svg'
import tag from '@primer/octicons/build/svg/tag-16.svg'
import trash from '@primer/octicons/build/svg/trash-16.svg'
import triangleDown from '@primer/octicons/build/svg/triangle-down-16.svg'
import vscode from '@primer/octicons/build/svg/vscode-16.svg'
import x from '@primer/octicons/build/svg/x-16.svg'
import xCircleFill from '@primer/octicons/build/svg/x-circle-fill-16.svg'

const ICONS = {
  skip,
  sync,
  sparkle,
  terminal,
  project,
  'file-diff': fileDiff,
  'cross-reference': crossReference,
  tasklist,
  quote,
  'list-unordered': listUnordered,
  'list-ordered': listOrdered,
  link,
  italic,
  heading,
  code,
  bold,
  check,
  'check-circle-fill': checkCircleFill,
  'chevron-down': chevronDown,
  'chevron-right': chevronRight,
  comment,
  copy,
  'dot-fill': dotFill,
  fold,
  gear,
  'git-branch': gitBranch,
  'git-commit': gitCommit,
  'git-merge': gitMerge,
  'git-pull-request': gitPullRequest,
  'git-pull-request-closed': gitPullRequestClosed,
  'git-pull-request-draft': gitPullRequestDraft,
  'issue-closed': issueClosed,
  'issue-opened': issueOpened,
  'issue-reopened': issueReopened,
  'link-external': linkExternal,
  lock,
  'mark-github': markGithub,
  milestone,
  paperclip,
  pencil,
  person,
  'person-add': personAdd,
  plus,
  repo,
  search,
  'sign-out': signOut,
  tag,
  trash,
  'triangle-down': triangleDown,
  vscode,
  x,
  'x-circle-fill': xCircleFill,
}

/** Raw SVG markup, for DOM built outside Mithril. */
export function iconSvg(name) {
  return ICONS[name]
}

/** An Octicon; color comes from `currentColor`, so set `color` on it or a parent. */
export function icon(name, attrs = {}) {
  return m('span.octicon', attrs, m.trust(ICONS[name]))
}

/** GitHub's icon and color class for an issue or pull request state. */
export function stateIcon(card) {
  if (card.type === 'issue')
    return card.state === 'open'
      ? ['issue-opened', 'open']
      : ['issue-closed', 'done']
  if (card.state === 'merged') return ['git-merge', 'done']
  if (card.state === 'closed') return ['git-pull-request-closed', 'closed']
  return card.pr.draft
    ? ['git-pull-request-draft', 'draft']
    : ['git-pull-request', 'open']
}

export function stateIconView({ card }) {
  const [name, cls] = stateIcon(card)
  return icon(name, {
    class: `state ${cls}`,
    title: `${m.t(card.type === 'pr' ? 'card.pull' : 'card.issue')} · ${m.t(`state.${cls === 'draft' ? 'draft' : card.state}`)}`,
  })
}

/** The colored "Open / Closed / Merged / Draft" pill from GitHub's issue header. */
export function stateLabelView({ card }) {
  const [name, cls] = stateIcon(card)
  const text = m.t(`state.${cls === 'draft' ? 'draft' : card.state}`)
  return m('span.state-label', { class: cls, title: text }, [
    icon(name),
    m('span.state-text', text),
  ])
}
